__turbopack_context__.v({
  "card": "Tg69fG_card",
  "cardBody": "Tg69fG_cardBody",
  "cardContent": "Tg69fG_cardContent",
  "cardEyebrow": "Tg69fG_cardEyebrow",
  "cardGrid": "Tg69fG_cardGrid",
  "cardImage": "Tg69fG_cardImage",
  "cardWavelength": "Tg69fG_cardWavelength",
  "dashedDivider": "Tg69fG_dashedDivider",
  "description": "Tg69fG_description",
  "header": "Tg69fG_header",
  "heading": "Tg69fG_heading",
  "inner": "Tg69fG_inner",
  "mapBackgroundImage": "Tg69fG_mapBackgroundImage",
  "mapFade": "Tg69fG_mapFade",
  "marker": "Tg69fG_marker",
  "mobileImageDim": "Tg69fG_mobileImageDim",
  "penetrationMap": "Tg69fG_penetrationMap",
  "section": "Tg69fG_section",
  "tissueLayerLabel": "Tg69fG_tissueLayerLabel",
  "wavelengthAnnotation": "Tg69fG_wavelengthAnnotation",
});
